import { useMemo } from "react";
import GridEditItensProcessoSolicitacao from "./Grid";

function ItensProcessoSection({ solicitacaoFields, solicitacaoProcessoItems, setSolicitacaoProcessoItems }) {
 
    const NomeForm = useMemo(() => {
        return `Edição dos Itens do Processo Associados ao Processo: ${solicitacaoFields?.compliance?.nomeProcesso}`;
    }, [solicitacaoFields?.compliance?.nomeProcesso]);

    return (
        <div className="row mt-4">
            <div className="col-12 col-md-12">
                <div className="block h-auto">
                    <div className="container-fluid">
                        <div className="row">

                            <div className="col-12 col-md-12 d-flex justify-content-between align-items-center">
                                <h2 className="mb-0">{NomeForm}</h2>

                                <button className="btn btn-menu d-flex align-items-end" type='button'>
                                    <i className="fa-solid fa-bars"></i>
                                </button>
                            </div>

                            <GridEditItensProcessoSolicitacao
                                solicitacaoProcessoItems={solicitacaoProcessoItems}
                                onUpdateSolicitacaoProcessoItems={setSolicitacaoProcessoItems}
                                idSolicitacao={solicitacaoFields?.id}
                                idProcesso={solicitacaoFields?.compliance?.idProcesso}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ItensProcessoSection;